import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { Form } from '@unform/web';
import styled from 'styled-components';

export const DatePickerWrapper = styled(Form)`
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.5rem;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const DatePicker = styled(KeyboardDateTimePicker)`
  width: 100%;
`;
